
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/return-refund-policy",
      function () {
        return require("private-next-pages/about/return-refund-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/return-refund-policy"])
      });
    }
  